

import { useState } from "react";
import Config from "../../Config";


import Info from "./Info";
import Directors from "./Directors";
import FreeDays from "./FreeDays";
import Support from "./Support";
import Payment from "./Payment";
import Reader from "./Reader";
import Account from "./Account";
import Settings from "./Settings";
import History from "./History";
import HistoryM from "./HistoryM";
import Cloud from "./Cloud";
import NewPlace from "./NewPlace";
 




function HomeView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }




    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
    var tab5 = " m_item ";
    var tab6 = " m_item ";
    var tab7 = " m_item ";
    var tab8 = " m_item ";
    var tab9 = " m_item ";
    var tab10 = " m_item ";
   
 

    if(props.mainView.viewSelected == "info") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "director") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "freedays") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "reader") tab4 = tab4 + " selected";
    if(props.mainView.viewSelected == "support") tab5 = tab5 + " selected";
    if(props.mainView.viewSelected == "pay") tab6 = tab6 + " selected";
    if(props.mainView.viewSelected == "settings") tab7 = tab7 + " selected";
    if(props.mainView.viewSelected == "history") tab8 = tab8 + " selected";
    if(props.mainView.viewSelected == "history_m") tab9 = tab9 + " selected";
    if(props.mainView.viewSelected == "query") tab9 = tab9 + " selected";
    if(props.mainView.viewSelected == "cloud") tab10 = tab10 + " selected";

    var subMenu = <div className="submenu">
            <div className={tab1} module="home" view="info" id="" onClick={props.mainView.quickGo} >Dane</div>
            <div className={tab2} module="home" view="director" id="" onClick={props.mainView.quickGo} >Dyrektorzy</div>
            <div className={tab3}  module="home" view="freedays" id="" onClick={props.mainView.quickGo} >Dni wolne</div>
            <div className={tab4}  module="home" view="reader" id="" onClick={props.mainView.quickGo} >Czytniki</div>
            <div className={tab5}  module="home" view="support" id="" onClick={props.mainView.quickGo} >Wsparcie</div>
            <div className={tab6}  module="home" view="pay" id="" onClick={props.mainView.quickGo} >Płatności</div>
            <div className={tab8}  module="home" view="history" id="" onClick={props.mainView.quickGo} >Historia</div>
            <div className={tab9}  module="home" view="history_m" id="" onClick={props.mainView.quickGo} >Powiadomienia</div>   
            <div className={tab10}  module="home" view="cloud" id="" onClick={props.mainView.quickGo} >Pliki i foldery</div>    
            <div className={tab7}  module="home" view="settings" id="" onClick={props.mainView.quickGo} >Ustawienia</div>                        
        
    </div>


 
    if(props.mainView.viewSelected == 'new')
    {
        document.title ="Nowa placówka"; 
        return (
            <div className="econtent ">  
                                
                  <NewPlace  userData={props.userData}  mainView={props.mainView}  />
            </div>
        )
    }
 

    if(props.mainView.viewSelected == 'info')
    {
        document.title ="Informacje o placówce / Start"; 
        return (
            <div className="econtent ">  
                {subMenu}                   
                  <Info  userData={props.userData}  mainView={props.mainView}  />
            </div>
        )
    }


    if(props.mainView.viewSelected == 'director')
    {
        document.title ="Dyrektorzy / Start"; 
        return (
            <div className="econtent ">
                    {subMenu}      
                  <Directors  userData={props.userData}  mainView={props.mainView} />
            </div>
        )
    }


    if(props.mainView.viewSelected == 'freedays')
    {
        document.title ="Dni wolne / Start"; 
        return (
            <div className="econtent ">
                    {subMenu}      
                  <FreeDays  userData={props.userData}  mainView={props.mainView}  />
            </div>        
        )
    }


    if(props.mainView.viewSelected == 'support')
    {
        document.title ="Wsparcie / Start"; 
        return (
            <div className="econtent ">
                    {subMenu}      
                  <Support  userData={props.userData}  mainView={props.mainView} />
            </div>
        )
    }

    
    if(props.mainView.viewSelected == 'pay')
    {
        document.title ="Płatności / Start"; 
        return (
            <div className="econtent ">
                    {subMenu}      
                  <Payment  userData={props.userData}  mainView={props.mainView} />
            </div>
        )
    }

    if(props.mainView.viewSelected == 'reader')
    {
        document.title ="Czytniki kart / Start"; 
        return (
            <div className="econtent ">
                    {subMenu}      
                  <Reader  userData={props.userData}  mainView={props.mainView} />
            </div>
        )
    }

    if(props.mainView.viewSelected == 'account')
    {
        document.title ="Ustawienia konta / Start"; 
        return (
            <div className="econtent ">
                    {subMenu}      
                <Account  userData={props.userData}  mainView={props.mainView} />
            </div>
        )
    }

    if(props.mainView.viewSelected == 'settings')
        {
            document.title ="Ustawienia konta / Ustawienia zaawansowane"; 
            return (
                <div className="econtent ">
                        {subMenu}      
                        <Settings  userData={props.userData}  mainView={props.mainView} />
                </div>
            )
        }


        if(props.mainView.viewSelected == 'history')
            {
                document.title ="Historia"; 
                return (
                    <div className="econtent ">
                            {subMenu}      
                            <History  userData={props.userData}  mainView={props.mainView} />
                    </div>
                )
            }    
            
            if(props.mainView.viewSelected == 'history_m')
                {
                    document.title ="Historia powiadomień"; 
                    return (
                        <div className="econtent ">
                                {subMenu}      
                                <HistoryM  userData={props.userData}  mainView={props.mainView} />
                        </div>
                    )
                }  
                
                if(props.mainView.viewSelected == 'cloud')
                    {
                        document.title ="Pliki i foldery"; 
                        return (
                            <div className="econtent ">
                                    {subMenu}      
                                    <Cloud  userData={props.userData}  mainView={props.mainView} />
                            </div>
                        )
                    }                   


    return (
        <div className="econtent ">
             
        </div>
    );
}

export default HomeView ;